import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Avatar,
  TextField,
  Button,
  Container,
  Alert,
  InputAdornment,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  Chat as ChatIcon,
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  Home as HomeIcon,
  NotificationsActive as NotificationsActiveIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const AdminNotification = () => {
  const navigate = useNavigate();
  const [user_id, setUserId] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem("CC_Token");
    localStorage.removeItem("user");
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    });
    setTimeout(() => navigate("/login"), 4000);
  };
  const baseUrl = process.env.REACT_APP_APP_URL;
  const token = localStorage.getItem("CC_Token");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user ? user.id : null;
  
  console.log(baseUrl);
  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs"); 
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(baseUrl);
    setUserId(userId);
    if (!userId) {
      setError("Utilisateur non trouvé. Veuillez vous reconnecter.");
      return;
    }

    axios
      .post(`${baseUrl}/api/notifications`,
        { user_id, title, message },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Notification créée avec succès !", {
          position: "top-right",
          autoClose: 3000,
        });
        // Reset form fields
        setTitle("");
        setMessage("");
        setError(null);
      })
      .catch((err) => {
        console.error(err);
        setError("Erreur lors de la création de la notification. Réessayez.");
      });
  };

  const handleProfile = () => {
    user.role =="admin" ? navigate("/ProfileAdmin") : navigate("/Profile");  // Redirection vers la page de profil
  };

  return (
    <div className="app">
      {/* Toast Container */}
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src={"../assets/cej.png"}
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="xs" // Use 'xs' to make it narrower on mobile
        sx={{
          marginTop: "100px",
          padding: "1rem", // Reduced padding
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: 3,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            marginBottom: "1rem",
            color: "#003366",
            fontWeight: "bold",
          }}
        >
          Nouvelle Notification
        </Typography>
        <Typography
          variant="subtitle2" // Smaller font size for subtitle
          sx={{
            textAlign: "center",
            color: "#666",
            marginBottom: "1rem",
          }}
        >
          Créez et envoyez une nouvelle notification.
        </Typography>
        <NotificationsActiveIcon
          sx={{
            fontSize: 40,
            color: "red",
            display: "block",
            margin: "0 auto",
          }}
        />
        {error && (
          <Alert
            severity="error"
            sx={{
              marginBottom: "1rem",
              backgroundColor: "#fdecea",
              color: "#d32f2f",
            }}
          >
            {error}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Titre"
            variant="outlined"
            fullWidth
            margin="normal"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <HomeIcon />
                </InputAdornment>
              ),
            }}
            sx={{ marginBottom: "1rem" }}
          />
          <TextField
            label="Message"
            variant="outlined"
            fullWidth
            margin="normal"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            multiline
            rows={4}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ChatIcon />
                </InputAdornment>
              ),
            }}
            sx={{ marginBottom: "1rem" }}
          />
          <Button
            variant="contained"
            fullWidth
            type="submit"
            sx={{
              backgroundColor: "#003366",
              color: "white",
              padding: "0.75rem",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#002244",
              },
            }}
          >
            Ajouter
          </Button>
        </form>
      </Container>

      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 1rem", // Reduced padding for bottom nav
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 25, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminChrono")}
          />
         <BottomNavigationAction
                label="Home"
                icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                sx={{ color: "#ffffff", minWidth: "auto" }}
                onClick={() => navigate(user.role === "admin" ? "/admin" : "/InstructorHome")
                }
              />
              <BottomNavigationAction
                label="Paiement"
                icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                sx={{ color: "#ffffff", minWidth: "auto" }}
                  onClick={() => navigate(user.role === "admin" ? "/AdminPaiment" : "/InstructorHome")
                }
              />
            </BottomNavigation>
      </Box>
    </div>
  );
};

export default AdminNotification;
